import BarChartComponent from "./BarChartComponent";

export default BarChartComponent;
